export enum FileType {
    CONFIGURATION_TABLE = 'configuration-table',
    VALIDATION_TABLE = 'validation-table',
    FLEET_DATA = 'fleet-data'
}
